import InputText from "./inputText";

export default InputText;